import * as amplitude from '@amplitude/analytics-browser';
import {AmplitudeEvent} from "./amplitudeEvents";
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY, {
    autocapture: {
        elementInteractions: true
    }
});

const sessionReplayTracking = sessionReplayPlugin({
    forceSessionTracking: true,
    sampleRate: 1,
});

amplitude.add(sessionReplayTracking);

export { amplitude };

export const setUserId = (userId: string): void => {
    amplitude.setUserId(userId);
};

// Track custom events
export const trackEvent = (eventName: string, eventData?: Record<string, any>) => {
    amplitude.track(eventName, eventData);
};

export const trackPageView = (pageName: string, userId?: string): void => {
    trackEvent(AmplitudeEvent.PageView, {page: pageName, userId: userId});
};
